import React, { lazy, Suspense, } from 'react';
import PropTypes from 'prop-types';
import { loadRemote, getEnvFromHostname, } from './utils';
import '../View.css';

const PathwaysSupportUi = lazy(
  async () => {
    const component = await loadRemote();
    return {
      default: component,
    };
  }
);

const SteppedPathways = (props) => {
  if (!props.token) {
    return (
      <div>Error: not logged in or can’t find token.</div>
    );
  }

  return (
    <div className="content">
      <Suspense fallback={<div>Loading...</div>}>
        <PathwaysSupportUi
          token={props.token}
          env={getEnvFromHostname()}
        />
      </Suspense>
    </div>
  );
};

SteppedPathways.propTypes = {
  token: PropTypes.shape({}).isRequired,
};

export default SteppedPathways;
